<template>
  <div class="form-field form-field--radio">
		<h2>
			{{ title }}
		</h2>

		<div class="image-radio">
			<img :src="img"/>
	
			<label v-for="choice in choices">

				<input
				type="radio"
				:name="name"
				:value="choice.value"
        v-model="value"
				/>
				<span class="image-radio__text">
					{{ choice.label }} <span class="image-radio__number">{{ choice.description }}</span>
				</span>
			</label>
		</div>
	</div>
</template>

<script>
export default {
	name: "ImageRadio",
	props: {
		title: {},
		name: {},
		modelValue: {},
		img: {},
		choices: {
			default: () => [
				{
					label: 'Geen',
					description: '0-1%',
					value: 'geen',
				},
				{
					label: 'Weinig',
					description: '1 - 15%',
					value: 'weinig',
				},
				{
					label: 'Duidelijk aanwezig',
					description: '15 - 45%',
					value: 'duidelijk_aanwezig',
				},
				{
					label: 'Plaatselijk veel',
					description: '40 - 70%',
					value: 'plaatselijk_veel',
				},
				{
					label: 'Veel',
					description: '70 - 100%',
					value: 'veel',
				},
			],
		},
	},
  data(){
    return {
      value: this.modelValue,
    };
  },
  watch: {
    value(){
      this.$emit('update:modelValue', this.value);
    }
  }
}
</script>

<style scoped>
	.image-radio {
		border-radius: 7px;
		overflow: hidden;
		border: solid 1px #dadde2;
		display: flex;
		flex-direction: column;
	}
	.image-radio img {
		height: 160px;
		width: 100%;
		object-fit: cover;
	}

	.image-radio__number {
		display: inline-block;
		margin-left: 12px;
		opacity: 0.5;
		font-size: 1.4rem;
		line-height: 1.43;
	}

	label {
		display: flex;
		align-items: center;
		position: relative;
		padding: 18px;
		border-top: 1px solid #dadde2;
		font-size: 1.6rem;
		line-height: 1.25;
		font-weight: normal;
		margin: 0;
	}

	input {
		position: absolute;
		right: 18px;
		top: 50%;
		transform: translateY(-50%);
		border: solid 1px #dadde2;
		width: 24px;
		height: 24px;
		border-radius: 50%;
		-webkit-appearance: none;
		appearance: none;
		background-color: white;
		margin: 0;
	}

	input:before {
		content: '';
		position: absolute;
		width: 10px;
		height: 9px;
		display: block;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 0;
		background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMiAxMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMSA2IDQgNCA2LTkiIHN0cm9rZT0iI0ZBRjhGNCIgc3Ryb2tlLXdpZHRoPSIxLjQiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+");
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
	}

	input:checked {
		border-color: #da503b;
		background: #da503b;
	}

	input:checked:before {
		opacity: 1;
	}
</style>
